/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectDailyTaskCommand } from '../../models/create-project-daily-task-command';
import { CreateProjectDailyTaskCommandResult } from '../../models/create-project-daily-task-command-result';

export interface ApiProjectDailyTasksCreateProjectDailyTaskPost$Params {
      body?: CreateProjectDailyTaskCommand
}

export function apiProjectDailyTasksCreateProjectDailyTaskPost(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTasksCreateProjectDailyTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTasksCreateProjectDailyTaskPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectDailyTaskCommandResult>;
    })
  );
}

apiProjectDailyTasksCreateProjectDailyTaskPost.PATH = '/api/ProjectDailyTasks/CreateProjectDailyTask';
